import {
    UPDATE_STEP_CUREENT,
} from '../actions/types'

const initialStepState = {
  current: 0,
}

const step = (state = initialStepState, action) => {
  switch (action.type) {
    case UPDATE_STEP_CUREENT:
      return {
        ...state,
        ...action.data,
      }
    default:
      return state
  }
}

export default step



// WEBPACK FOOTER //
// ./src/reducers/step.js